import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DataStorageService } from "../../../services/data-storage.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { PetInsuranceData } from "../../../models";
import { ApiHttpService } from "../../../services/api-http.service";
import { environment } from "../../../../environments/environment";
import { LoadingService } from "../../../services/loading.service";

@Component({
  selector: 'cpf-pet-card-list',
  templateUrl: './pet-card-list.component.html',
  styleUrls: ['./pet-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PetCardListComponent {
  @Input() public selectedIndexes: number[] = [];
  @Input() public allowMultipleSelect: boolean = true;
  @Input() public showButton: boolean = false;
  @Input() public showFlippedCards: boolean = false;
  @Input() public showBuyInsuranceCard: boolean = false;

  @Output() public onCardSelect: EventEmitter<number> = new EventEmitter<number>();
  @Output() public onCardActionButtonClick: EventEmitter<void> = new EventEmitter<void>();

  private _allPets: PetInsuranceData[] = [];
  public showPets: PetInsuranceData[] = [];
  public flippedCards: number[] = [];
  public isShowAllPets = false;

  constructor(private dataStorageService: DataStorageService,
              private router: Router,
              private translateService: TranslateService,
              private apiHttpService: ApiHttpService,
              private loadingService: LoadingService) {
    this.dataStorageService.loaded$.subscribe((loaded) => {
      if (loaded) {
        this.selectedIndexes = [0];
      }
    });
  }

  @Input() public set allPets(pets: PetInsuranceData[]) {
    this._allPets = pets;
    this.showPets = [...pets.filter(pet => pet.contractStatus !== 'expired')];
  }

  showAllPets() {
    this.isShowAllPets = true;
    this.showPets = [...this._allPets];
  }

  isCardSelected(i: number) {
    return this.selectedIndexes.includes(i);
  }

  selectCard(i: number) {
    if (!this.allowMultipleSelect) {
      this.onCardSelect.emit(i);
      this.selectedIndexes = [i];
    } else if (this.selectedIndexes.includes(i)) {
      this.selectedIndexes = this.selectedIndexes.filter(index => index !== i);
    } else {
      this.selectedIndexes.push(i);
    }
  }

  isCardFlipped(i: number) {
    return this.flippedCards.includes(i);
  }

  cardClicked(index: number) {
    if (this.flippedCards.includes(index)) {
      this.flippedCards = this.flippedCards.filter(i => i !== index);
    } else {
      this.flippedCards.push(index);
    }
  }

  async openClosingPage() {
    const lang = this.translateService.getCurrentLang();
    const loader = this.loadingService.open();
    let result = null;
    try {
      result = await this.apiHttpService.createClosingSession();
    } finally {
      loader.close();
    }
    const baseUrl = `${environment.petClosingUrl}/#/pet-info?lang=${lang}`;
    const url = result?.sessionId ? `${baseUrl}&sessionId=${result.sessionId}` : baseUrl;
    window.open(url, '_blank');
  }

  hideExpiredPets() {
    this.showPets = [...this._allPets.filter(pet => pet.contractStatus !== 'expired')];
    this.isShowAllPets = false;
  }
}
